export const getCountries = async country => {
  switch (country) {
    case 'en':
      return (await import('assets/data/countries/en.json')).default
    case 'sv':
      return (await import('assets/data/countries/sv.json')).default
    default:
      return (await import('assets/data/countries/fi.json')).default
  }
}

export const getCountriesSync = country => {
  switch (country) {
    case 'en':
      return require('assets/data/countries/en.json')
    case 'sv':
      return require('assets/data/countries/sv.json')
    default:
      return require('assets/data/countries/fi.json')
  }
}
